import LiveEvent from "../../components/live/live";
import Modal from "../../components/modal/modal";

document.addEventListener('DOMContentLoaded', () => {
  const machinesInput = document.querySelector('[name="RentForm[user_count][0]"]');
  const nvmeInput = document.querySelector('[name="RentForm[ssd_capacity][0]"]');
  const bandwidthInput = document.querySelector('[name="RentForm[hdd_capacity][0]"]');
  const cpuInput = document.querySelector('[name="RentForm[core_count][0]"]');
  const ramCapacity = document.querySelector('[name="RentForm[ram_capacity][0]"]');
  const totalElement = document.querySelector('.constructor__total');

  function calculateTotal() {
    let total = 0;

    const cpu = parseInt(cpuInput.value, 10);
    const ram = parseInt(ramCapacity.value, 10);
    const nvme = parseInt(nvmeInput.value, 10);
    const bandwidth = parseInt(bandwidthInput.value, 10);

    if (cpu > 1) {
      total += cpu * 520;
    }

    if (ram > 1) {
      total += ram * 300;
    }

    if (nvme >= 20) {
      total += (nvme / 20) * 200;
    }

    if (bandwidth > 100) {
      total += ((bandwidth - 100) / 100) * 3000;
    }

    totalElement.textContent = `от ${Math.round(total)} ₽/мес`;
  }

  if (cpuInput && ramCapacity && nvmeInput && bandwidthInput) {
    cpuInput.addEventListener('change', calculateTotal);
    ramCapacity.addEventListener('change', calculateTotal);
    nvmeInput.addEventListener('change', calculateTotal);
    bandwidthInput.addEventListener('change', calculateTotal);

    calculateTotal();
  }

  new LiveEvent('click', '[data-modal-calc-rent]', function openModal(e) {
    e.preventDefault();
    let link = this;
    let modal = new Modal(this, {
      closerText: '',
      onFormSuccess: function () {
        if (link.dataset.goal) {
          let action = 'click';
          if (link.dataset.goalAction) {
            action = link.dataset.goalAction;
          }
          window.goal(link.dataset.goal, action);
          if (link.dataset.goalFacebook && link.dataset.goalAction) {
            window.fbq('track', link.dataset.goalFacebook);
          }
        }
      },
      onAfterOpen() {
        const modalForm = document.querySelector('.bitrix-modal__form');
        const modalMachinesInput = modalForm.querySelector('[name="RentForm[user_count][0]"]');
        const modalServersInput = modalForm.querySelector('[name="RentForm[ssd_capacity][0]"]');
        const modalOfficeMachinesInput = modalForm.querySelector('[name="RentForm[hdd_capacity][0]"]');
        const modalCpuInput = modalForm.querySelector('[name="RentForm[core_count][0]"]');
        const modalRamCapacity = modalForm.querySelector('[name="RentForm[ram_capacity][0]"]');

        const excludedFields = ['total_params', 'user_count', 'ssd_capacity', 'hdd_capacity', 'core_count', 'ram_capacity'];
        excludedFields.forEach((fieldName) => {
          const field = modalForm.querySelector(`.${fieldName}`);
          if (field) {
            field.style.setProperty('display', 'none');
          }
        });

        if (modalMachinesInput) {
          modalMachinesInput.value = machinesInput.value;
          const machinesShow = modalForm.querySelector('[data-range-single-show]');
          if (machinesShow) machinesShow.textContent = machinesInput.value;
        }

        if (modalServersInput) {
          modalServersInput.value = nvmeInput.value;
        }

        if (modalOfficeMachinesInput) {
          modalOfficeMachinesInput.value = bandwidthInput.value;
        }

        if (modalCpuInput) {
          modalCpuInput.value = cpuInput.value;
        }

        if (modalRamCapacity) {
          modalRamCapacity.value = ramCapacity.value;
        }
      },
    });
    return false;
  });
});